export const EDUCATION_VOTING_PRODUCT = "MZN_SMART_VOTING";
export type EducationEligibility = {
  organizerId: string;
  organizerName: string;
  eligible: boolean;
  reason: "EDUCATION_REQUIRED" | "ALREADY_ACTIVE" | "ELIGIBLE";
  alreadyActive: boolean;
};
export type EligibilityPage = { items: EducationEligibility[]; freeForLife: true; nextCursor: string | null };
export function parseEligibilityPage(value: unknown): EligibilityPage {
  if (!value || typeof value !== "object") throw new Error("Invalid service eligibility");
  const page = value as EligibilityPage;
  if (page.freeForLife !== true || !Array.isArray(page.items) ||
    (page.nextCursor !== null && typeof page.nextCursor !== "string") ||
    page.items.some((item) => !item || typeof item !== "object" ||
      typeof item.organizerId !== "string" || !item.organizerId ||
      typeof item.organizerName !== "string" || !item.organizerName ||
      typeof item.eligible !== "boolean" || typeof item.alreadyActive !== "boolean" ||
      !["EDUCATION_REQUIRED", "ALREADY_ACTIVE", "ELIGIBLE"].includes(item.reason)))
    throw new Error("Invalid service eligibility");
  return page;
}
export function canActivateEducation(item: EducationEligibility | undefined): boolean {
  return !!item && item.eligible && !item.alreadyActive && item.reason === "ELIGIBLE";
}
export function verifyEducationActivation(value: unknown, organizerId: string): void {
  if (!value || typeof value !== "object") throw new Error("Invalid service activation");
  const result = value as Record<string, unknown>;
  if (result.organizerId !== organizerId || result.serviceProductId !== EDUCATION_VOTING_PRODUCT ||
    result.subscriptionStatus !== "ACTIVE" || result.freeForLife !== true || result.expiresAtEpochMillis !== null ||
    typeof result.replayed !== "boolean") throw new Error("Invalid service activation");
}
